import { render, staticRenderFns } from "./pointContent.vue?vue&type=template&id=c8f89080&scoped=true"
import script from "./pointContent.vue?vue&type=script&lang=ts"
export * from "./pointContent.vue?vue&type=script&lang=ts"
import style0 from "./pointContent.vue?vue&type=style&index=0&id=c8f89080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f89080",
  null
  
)

export default component.exports